export enum MessageTypeEnum {
  PRIVATE_MESSAGE = 'PRIVATE_MESSAGE',
}
